<div class="layout-topbar">
    <div class="topbar-left">
        <a
            #menubutton
            tabindex="0"
            class="menu-button p-trigger"
            (click)="onMenuButtonClick()"
        >
            <i class="pi pi-chevron-left"></i>
        </a>
        <img
            class="horizontal-logo"
            [routerLink]="['/']"
            [src]="'assets/layout/images/logo-' + logo + '.svg'"
            alt="diamond-layout"
        />
        <span class="topbar-separator"></span>
        <!-- <app-breadcrumb></app-breadcrumb> -->
        <img
            class="mobile-logo"
            [src]="'assets/layout/images/logo-' + logo + '.svg'"
            alt="diamond-layout"
        />
    </div>

    <div class="layout-topbar-menu-section">
        <app-sidebar></app-sidebar>
    </div>
    <div class="layout-mask modal-in"></div>

    <div class="topbar-right">
        <ul class="topbar-menu">
            <li class=" static sm:relative border-right-1 pr-3" [style]="{'border-color': '#d8d8d8'}">
                <p-dropdown
                    [options]="languages"
                    (onChange)="languageChanged($event)"
                    [(ngModel)]="selectedLanguage"
                    [placeholder]="'SELECT_LANGUAGE' | translate"
                    size="small"
                    optionLabel="name"
                    optionValue="value"
                ></p-dropdown>
            </li>
            <li class="static sm:relative ml-4">
                <a
                    tabindex="0"
                    pStyleClass="@next"
                    class="flex w-10rem"
                    enterFromClass="hidden"
                    enterActiveClass="scalein"
                    leaveToClass="hidden"
                    leaveActiveClass="fadeout"
                    [hideOnOutsideClick]="true"
                >
                    <i class="pi pi-user text-sm mr-2"></i>
                    <span class="text-sm font-semibold" *ngIf="userProfile">{{userProfile.given_name}} {{userProfile.family_name}}</span>
                </a>
                <ul
                    class="list-none p-3 m-0 border-round shadow-2 absolute surface-overlay hidden origin-top w-full sm:w-12rem mt-2 right-0 z-5 top-auto"
                >
                    <li>
                        <a
                            pRipple
                            class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
                        >
                            <i class="pi pi-user mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">{{'PROFILE' | translate}}</span>
                            </span>
                        </a>
                        <a
                            pRipple
                            class="flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
                            (click)="onLogout()"
                        >
                            <i class="pi pi-power-off mr-3"></i>
                            <span class="flex flex-column">
                                <span class="font-semibold">{{'LOGOUT' | translate}}</span>
                            </span>
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</div>
